<script setup lang="ts">
    import { IWidget, IWidgetType } from '@/js/services/api/widget/types';
    import GridChart from './GridChart.vue';
    import TextWidget from './TextWidget.vue';
    import {
        isGraphWidget,
        isPromptWidget,
        isStaticGraphWidget,
        isTextWidget,
        isTopListWidget,
    } from '@/js/utils/widgetUtils';
    import PromptWidget from './PromptWidget.vue';
    import TopListWidget from './TopListWidget.vue';
    import StaticGraphWidget from './StaticGraphWidget.vue';

    interface Props {
        widget: IWidget<IWidgetType>;
        dashboardId?: string;
        canEdit?: boolean;
    }

    const props = defineProps<Props>();

    defineEmits<{
        (e: 'removeInvalidFilter'): void;
    }>();
</script>
<template>
    <GridChart
        v-if="props.widget && isGraphWidget(props.widget)"
        :widget="props.widget"
        :dashboard-id="props.dashboardId"
        :can-edit="props.canEdit"
        @remove-invalid-filter="$emit('removeInvalidFilter')"
    />
    <div
        v-if="props.widget && isTextWidget(props.widget)"
        class="h-full overflow-y-auto custom-scrollbar"
    >
        <TextWidget :widget="props.widget" />
    </div>
    <PromptWidget v-if="props.widget && isPromptWidget(props.widget)" :widget="props.widget" />
    <div
        v-if="props.widget && isTopListWidget(props.widget)"
        class="px-4 h-full overflow-y-auto custom-scrollbar"
    >
        <TopListWidget :widget="props.widget" />
    </div>
    <StaticGraphWidget
        v-if="props.widget && isStaticGraphWidget(props.widget)"
        :widget="props.widget"
    />
</template>
